import script from "./BusinessOwnerDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessOwnerDashboard.vue?vue&type=script&setup=true&lang=js"

import "./BusinessOwnerDashboard.vue?vue&type=style&index=0&id=d8692798&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8692798"]])

export default __exports__